import { render, staticRenderFns } from "./FixedBottomRightArea.vue?vue&type=template&id=73543737&scoped=true"
import script from "./FixedBottomRightArea.vue?vue&type=script&lang=js"
export * from "./FixedBottomRightArea.vue?vue&type=script&lang=js"
import style0 from "./FixedBottomRightArea.vue?vue&type=style&index=0&id=73543737&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.34_cache-loader@4.1.0_webpack@4.47.0__css-load_359e2a22b61d78988ed9bf0e7b495bd0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73543737",
  null
  
)

export default component.exports